import { Roles } from '@ucc/unified-admin-common'

import { useConnectedUserContext } from 'components/contexts/ConnectedUserContext'

const useIsUserSystemUser = () => {
  const iAm = useConnectedUserContext()
  const isUserSystemUser = iAm ? iAm.systemRoles?.includes(Roles.SystemUser) : false

  return {
    isUserSystemUser,
  }
}

export default useIsUserSystemUser
